module.exports = __webpack_public_path__ + "static/media/snake@768.5e73ea89.png";